<template>
    <v-toolbar
        class="pl-0 pr-0 vw-100 border-radius-left-right primarybar-bg"
        height="50"
        dense
        dark
        flat
        :class="{ 'topbar-full': $breakpoint.mdAndDown }"
    >
        <!-- {{ live }} -->
        <v-fade-transition leave-absolute>
            <live-label
                :text="
                    getText(live)?.toUpperCase() + (title ? ' / ' + title : '')
                "
                :color="getColor(live)"
                left
            ></live-label>
        </v-fade-transition>
        <div
            class="d-flex border-radius-left align-self-stretch white--text py-2 col-6 px-2 topbar"
            :class="{
                'align-items-center':
                    ['horse-racing', 'greyhound-racing'].includes(
                        $route.params.category
                    ) || !$breakpoint.mdAndUp
            }"
        >
            <div
                v-if="openable && $breakpoint.mdAndUp"
                class="align-self-center"
            >
                <v-fade-transition>
                    <v-icon
                        v-if="open"
                        color="white"
                        class="flex-0 mr-2"
                        size="14"
                    >
                        mdi-minus
                    </v-icon>
                    <v-icon v-else color="white" class="flex-0 mr-2" size="14">
                        mdi-plus
                    </v-icon>
                </v-fade-transition>
            </div>
            <v-btn
                class="caption ma-0 px-1 py-2 d-flex flex-column white--text text-capitalize text-left primary-title btn-fixed"
                color="transparent"
                depressed
                tile
                height="100%"
                :to="to"
                @click.native.stop
            >
                <!-- <span class="match-title">{{ subtitle }}</span> -->
                <!-- <br v-if="subtitle" /> -->
                <span class="match-time" :class="{ 'wrap-subtitle': subtitle }">
                    {{ subtitle }}
                </span>
                <!-- <span class="match-time">{{ title }}</span> -->
            </v-btn>

            <span
                v-if="
                    ['horse-racing', 'greyhound-racing'].includes(
                        $route.params.category
                    )
                "
                class="event-spec-text"
                >{{ name }}</span
            >
            <v-tooltip v-if="!$breakpoint.mdAndUp" bottom>
                <template #activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on">
                        <v-btn v-if="video || (tv && live)" icon>
                            <v-icon>mdi-play</v-icon>
                        </v-btn>
                    </div>
                </template>
                <span>In-Play</span>
            </v-tooltip>
            <div
                v-if="!$breakpoint.mdAndUp"
                :class="{
                    'ml-auto': ['horse-racing', 'greyhound-racing'].includes(
                        $route.params.category
                    )
                }"
            >
                <favorite-btn
                    v-if="favoriteBtn"
                    :is-favorite="isFavorite"
                    :market-id="marketId"
                    :game="$route.params.category?.split('-').join(' ')"
                />
            </div>
        </div>
        <!-- <span class="match-type">
        {{ name }}
      </span> -->
        <!-- <v-spacer /> -->
        <div class="px-0 py-0 d-flex align-items-center w-100">
            <!-- v-if="!$auth.loggedIn" no-gutters -->
            <div
                :class="{
                    'mx-auto':
                        $auth.loggedIn &&
                        $breakpoint.mdAndUp &&
                        !['horse-racing', 'greyhound-racing'].includes(
                            $route.params.category
                        ),
                    'custom-style-hr-ghr--desktop':
                        $auth.loggedIn &&
                        $breakpoint.mdAndUp &&
                        ['horse-racing', 'greyhound-racing'].includes(
                            $route.params.category
                        ),
                    'custom-left-margin mr-auto':
                        (!$auth.loggedIn || !$breakpoint.mdAndUp) &&
                        !['horse-racing', 'greyhound-racing'].includes(
                            $route.params.category
                        ),
                    'custom-style-hr-ghr--mobile':
                        (!$auth.loggedIn || !$breakpoint.mdAndUp) &&
                        ['horse-racing', 'greyhound-racing'].includes(
                            $route.params.category
                        )
                }"
                class="d-flex align-items-center"
            >
                <v-col
                    v-for="(text, i) in sideText"
                    :key="i"
                    cols="6"
                    class="caption font-weight-bold"
                    :class="{
                        'text-center': $breakpoint.xsOnly,
                        // ' text-right pt-0 px-4 pr-1 pb-0': $breakpoint.smAndUp && i === 0,
                        // ' text-left pt-0 px-4 pl-7 pb-0': $breakpoint.smAndUp && i === 1,
                        'py-0': $breakpoint.smAndDown,
                        'text-white': $vuetify.theme.dark
                    }"
                >
                    {{ text }}
                </v-col>
            </div>
            <v-tooltip v-if="$breakpoint.mdAndUp" bottom>
                <template #activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on">
                        <v-btn v-if="video || (tv && live)" icon>
                            <v-icon>mdi-play</v-icon>
                        </v-btn>
                    </div>
                </template>
                <span>In-Play</span>
            </v-tooltip>
            <!-- <div v-if="!tv" class="text-capitalize">{{ title }}</div> -->
            <v-tooltip bottom>
                <template #activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on">
                        <v-btn
                            v-if="name === 'UOFGame'"
                            :to="`${to}/?tab=1`"
                            icon
                            color="amber"
                            class="mdi-crown"
                        >
                            <v-icon>mdi-crown</v-icon>
                        </v-btn>
                    </div>
                </template>
                <span class="text-uppercase"
                    >PREMIUM
                    {{
                        $route.params.category
                            ? $route.params.category
                            : "cricket"
                    }}</span
                >
            </v-tooltip>
            <div
                v-if="$breakpoint.mdAndUp"
                :class="{
                    'ml-auto': ['horse-racing', 'greyhound-racing'].includes(
                        $route.params.category
                    )
                }"
            >
                <favorite-btn
                    v-if="favoriteBtn"
                    :is-favorite="isFavorite"
                    :market-id="marketId"
                    :game="$route.params.category?.split('-').join(' ')"
                />
            </div>
            <div v-if="openable" class="d-none align-self-center">
                <v-fade-transition>
                    <v-icon
                        v-if="open"
                        color="white"
                        class="flex-0 mr-2"
                        size="14"
                    >
                        mdi-minus
                    </v-icon>
                    <v-icon v-else color="white" class="flex-0 mr-2" size="14">
                        mdi-plus
                    </v-icon>
                </v-fade-transition>
            </div>
        </div>
    </v-toolbar>
</template>

<script>
import FavoriteBtn from "@/components/FavoriteBtn"
import LiveLabel from "@/components/LiveLabel"
export default {
    name: "PrimaryBar",
    components: { LiveLabel, FavoriteBtn },
    props: {
        title: { type: String, default: "", required: true },
        subtitle: { type: String, default: "", required: true },
        name: { type: String, default: "", required: true },
        to: { type: String, default: "", required: false },
        live: { type: Boolean, default: false, required: false },
        video: { type: Boolean, default: false, required: false },
        open: { type: Boolean, default: false, required: false },
        openable: { type: Boolean, default: true, required: false },
        favoriteBtn: { type: Boolean, default: false, required: false },
        isFavorite: { type: Boolean, default: false, required: false },
        marketId: { type: String, default: "", required: false },
        isthreeEt: { type: String, default: "", required: false },
        tv: { type: String, default: "", required: false },
        sideText: { type: Array, default: () => ["Back", "Lay"] }
    },
    methods: {
        getText(live) {
            return live ? "Live" : "Upcoming"
        },
        getColor(live) {
            return live ? "green" : "blue"
        },
        getTitle(startTime) {
            const fixturedate = this.$moment(startTime)
            // if (this.showDate) {
            if (this.$moment().isSame(this.$moment(fixturedate), "week")) {
                // return this.$moment(fixturedate).calendar()
                return this.$moment(fixturedate).endOf("day").fromNow()
            } else {
                // return this.$moment(fixturedate).format('ddd, DD/MM hh:mm A')
                return this.$moment(fixturedate).endOf("day").fromNow()
            }
            // } else {
            //   return false
            // }
        }
    }
}
</script>
<style lang="scss" scoped>
$primary: var(--v-primary-base);
.vw-100 {
    width: calc(100vw - 20px);
    .v-toolbar__content {
        width: calc(100vw - 20px);
    }
}
.v-toolbar__content .v-btn.v-btn--icon.v-size--default,
.v-toolbar__extension .v-btn.v-btn--icon.v-size--default {
    height: auto;
    width: auto;
    padding: 0 0.2rem;
}
.v-application--is-ltr .v-toolbar__content > .v-btn.v-btn--icon:last-child,
.v-application--is-ltr .v-toolbar__extension > .v-btn.v-btn--icon:last-child {
    margin: 0 !important;
}
.topbar-full {
    background-color: $primary !important;
    border: 0.08rem solid $primary;
    box-shadow: 0px 0px 5px 0px $primary;
    border-color: $primary;
    border-bottom: 0;
    // .wrap-subtitle {
    //   // max-width: 60%;
    //   white-space: normal;
    //   word-wrap: break-word;
    //   @media only screen and (max-width: 767px) {
    //     max-width: calc(100% - 30px);
    //     text-overflow: ellipsis;
    //     height: 28px;
    //     overflow: hidden;
    //   }
    // }
}
.wrap-subtitle {
    text-overflow: ellipsis;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    white-space: normal;
    word-wrap: break-word;
}
.pl-0 .v-toolbar__content {
    padding-left: 0 !important;
    padding-right: 0 !important;
}
.topbar {
    background-color: $primary !important;
    /* border: 0.08rem solid #fa7b04; */
    /* box-shadow: 0px 0px 5px 0px #fa7b04; */
    /* border-color: #fa7b04; */
    /* border-bottom: 0; */
    overflow: hidden;

    // @media only screen and (max-width: 992px) {
    //   width: 100%;
    // }
}
.border-radius-left-right {
    border-top-right-radius: 1.1rem !important;
    border-top-left-radius: 1.1rem !important;
}
.border-radius-left {
    border-top-left-radius: 1.1rem !important;
}
.match-title {
    width: (100vw - 50vw);
    white-space: normal;
    word-wrap: break-word;
}
a.caption.ma-0.px-1.py-2.d-flex.flex-column.white--text.text-capitalize.text-left.primary-title.v-btn.v-btn--has-bg.v-btn--router.v-btn--tile.theme--dark.v-size--default.transparent.btn-fixed {
    flex: auto;
    align-items: flex-start;
}
.event-spec-text {
    font-size: 0.625rem !important;
    font-weight: 400;
    text-wrap: nowrap;

    @media only screen and (max-width: 768px) {
        font-size: 0.5rem !important;
    }
    @media only screen and (max-width: 280px) {
        text-wrap: pretty;
        line-height: 12px;
    }
}
.custom-left-margin {
    margin-left: 52%;
    @media screen and (max-width: 900px) {
        margin-left: 47%;
    }
    @media screen and (max-width: 800px) {
        margin-left: 40%;
    }
    @media screen and (max-width: 700px) {
        margin-left: 28%;
    }
    @media screen and (max-width: 599px) {
        margin-left: 56%;
    }
    @media screen and (max-width: 500px) {
        margin-left: 45%;
    }
    @media screen and (max-width: 400px) {
        margin-left: 35%;
    }
    @media screen and (max-width: 350px) {
        margin-left: 28%;
    }
}
.custom-style-hr-ghr--desktop {
    margin-left: 64%;
    @media screen and (max-width: 1263px) {
        margin-left: 50%;
    }
}
.custom-style-hr-ghr--mobile {
    margin-left: 75%;
    @media screen and (max-width: 1263px) {
        margin-left: 68%;
    }
    @media screen and (max-width: 959px) {
        margin-left: 70%;
    }
    @media screen and (max-width: 800px) {
        margin-left: 65%;
    }
    @media screen and (max-width: 700px) {
        margin-left: 58%;
    }
    @media screen and (max-width: 599px) {
        margin-left: 48%;
    }
    @media screen and (max-width: 475px) {
        margin-left: 35%;
    }
    @media screen and (max-width: 375px) {
        margin-left: 30%;
    }
}
</style>
